<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="ack01"><a id="page07">
</a><div class="chapterHead"><a id="page07">
</a><h2 class="chapterTitle1"><a id="page07"><span class="xrefInternal"></span></a><a href="#/9780061745287_contents#ack_01"><span class="bold">Acknowledgments</span></a></h2>
</div>
<div class="chapterBody">
<p class="para">Many thanks to my original editor, Barbara Moulton, for sharing my enthusiasm for <em class="italic">Is It a Choice?</em> at a time when nearly no one else did; to Alison Ames, for generously providing a very comfortable place to work; to Barry Owen, for his help with the proposal; and to Ann Northrop, for her wisdom, encouragement, and support.</p>
<p class="para">Special thanks to all those who suggested questions, offered sage advice, and/or read the manuscript, including Lisa Bach, Dr. Betty Berzon, Mark Burstein, Cate Corcoran, Christine Egan, Ilan Greenberg, Cynthia Grossman, Fred Hertz’s grandmother, Alex Lash, Aaron Levaco, Peggy Levine, Matthew Lore, Cecilia Marcus (my mom), May Marcus (my grandmother), Steven Mazzola, Bill Megevick, Judy Montague, Jessica Morris, Joel Roselin, Phil Roselin, Bill Russell, Stuart Schear, Bill Smith, Scott Terranella, and Nick Wingfield.</p>
<p class="para">For the second edition, many thanks to my editor, Liz Perle, and her eagle-eyed assistant David Hennessy, for their unwavering support and help. Thank you also to my researchers, Jennifer Finlay and Stephen Milioti. Thank you, Nancy Kokolj, for reviewing the finished manuscript. And a special thank you to my meticulous copy editor, Carl Walesa.</p>
<p class="para">For the third edition, thank you to my agent, Joy Harris, my editor Gideon Weil, Carl Walesa (again), and the many people from around the world who contributed new questions <a id="page08">and offered their suggestions. A special thanks to Ryan Marcus, my nephew, who made certain that this latest edition is anchored in the twenty-first century. Thank you again to Stephen Milioti for making certain my answers were grounded in fact; and thank you, as well, to Don Press and Bronwen Pardes. And, as always, to my partner in life, Barney M. Karpfinger, thank you for so much.</a></p><a id="page08">
</a></div><a id="page08">
</a></div><a id="page08">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061745287_frontmatterpage.vue?3f2c4e24